import { Row } from "react-bootstrap";

export default function NoResults() {
  return (
    <Row className="d-flex justify-content-center py-2">
      No results to display
    </Row>
  );
}
